<template>
  <div v-if="shouldRender">
    <div class="pb-4 text-lg font-bold">Reaction groups</div>    
    <div class="flex font-bold text-lg text-whit">
    
      <div
        @click="nav('❤')"
        v-if="reactions['❤'] > 0"
        class="reaction-tile cursor-pointer py-2 px-4  flex flex-col mr-2">
      <div class="flex items-center"><div class="text-2xl reaction-img" v-html="parsedSymbol('❤')"></div></div>
      <div class="text-xs self-end count">{{reactions['❤']}}</div>
    </div>
    <div
      @click="nav('👍')"
      v-if="reactions['👍'] > 0"
      class="reaction-tile cursor-pointer py-2 px-4 flex flex-col mr-2">
      <div class="flex items-center"><div class="text-2xl reaction-img" v-html="parsedSymbol('👍')"></div></div>
      <div class="text-xs self-end count">{{reactions['👍']}}</div>
    </div>
    <div
      @click="nav('👎')"
      v-if="reactions['👎'] > 0"
      class="reaction-tile cursor-pointer py-2 px-4 flex flex-col mr-2">
      <div class="flex items-center"><div class="text-2xl reaction-img" v-html="parsedSymbol('👎')"></div></div>
      <div class="text-xs self-end count">{{reactions['👎']}}</div>
    </div>
    <div
      @click="nav('‼')"
      v-if="reactions['‼'] > 0"
      class="reaction-tile cursor-pointer py-2 px-4 flex flex-col mr-2">
      <div class="flex items-center"><div class="text-2xl reaction-img" v-html="parsedSymbol('‼')"></div></div>
      <div class="text-xs self-end count">{{reactions['‼']}}</div>
    </div>
    <div
      @click="nav('❓')"
      v-if="reactions['❓'] > 0"
      class="reaction-tile cursor-pointer py-2 px-4 flex flex-col mr-2">
      <div class="flex items-center"><div class="text-2xl reaction-img" v-html="parsedSymbol('❓')"></div></div>
      <div class="text-xs self-end count">{{reactions['❓']}}</div>
    </div>
    <div
      @click="nav('😂')"
      v-if="reactions['😂'] > 0"
      class="reaction-tile cursor-pointer py-2 px-4 flex flex-col mr-2">
      <div class="flex items-center"><div class="text-2xl reaction-img" v-html="parsedSymbol('😂')"></div></div>
      <div class="text-xs self-end count">{{reactions['😂']}}</div>
    </div>
  </div>
  </div>
</template>

<script>
 import {mapState} from 'vuex';
 export default {
   computed: {
     ...mapState({
       reactions: state => state.reactionTags
     }),
     shouldRender () {
       return Object.keys(this.reactions).some(k => this.reactions[k] > 0)
     }
   },

   methods: {
     parsedSymbol (sym) {
       return twemoji.parse(sym)
     },
     nav (tag) {
       this.$nav('notes',
                 {
                   tags: ':t:' + tag,
                   folder: '/'
                 }
       );

       this.$emit('select', tag);
     },
   }

 };
</script>

<style scoped>
 .reaction-tile:last-child {
   margin-right: 0;
 }

 .reaction-img {
   background: radial-gradient(closest-side, rgba(0,0,0,.2), rgba(0,0,0,0));
 }

 .count {
   position: relative;
   top: -5px;
 }
</style>
